/* src/app/starshading/starshading.component.scss */
.container {
  position: relative;
  margin: 0;
  padding: 0;
  width: 124px;
  display: flex;
  align-items: center;
}
.container .rating {
  color: #e7711b;
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  width: calc((var(--rating) - 1) * 20%);
  height: 22px;
  background-color: orange;
  -webkit-mask-image: url(/assets/img/icons/cb_star_active.svg);
  mask-image: url(/assets/img/icons/cb_star_active.svg);
}
.container .empty {
  width: 124px;
  height: 22px;
  top: 0;
  background-color: #808080;
  -webkit-mask-image: url(/assets/img/icons/cb_star_inactive.svg);
  mask-image: url(/assets/img/icons/cb_star_inactive.svg);
}
/*# sourceMappingURL=starshading.component.css.map */
